<div class="modal-header">
    <!--<h4 class="modal-title">Editar Promociones</h4>-->
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <div class="row mb-3">
            <div class="col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>Lista de CODIGOS</mat-label>
                    <input matInput placeholder="11111,222222,33333" [(ngModel)]="codigosList">
                </mat-form-field>
            </div>
            <div class="col-md-6 d-flex align-items-center">
                <!-- <button mat-stroked-button color="primary" class="me-2" matTooltip="Agregar nuevas filas de la lista" (click)="addRowsFromList()">Agregar <mat-icon>add</mat-icon></button>                 -->
                <!-- <button mat-stroked-button color="primary" class="me-2" matTooltip="Subir promociones" (click)="fileInput.click()">Subir <mat-icon>file_upload</mat-icon></button> -->
                <input hidden (change)="onFileSelected($event)" #fileInput type="file" accept=".xlsx, .xls">
                <button mat-stroked-button color="primary" (click)="downloadTemplate()" matTooltip="Descargar plantilla">Plantilla <mat-icon>file_download</mat-icon></button>
            </div>
        </div>

        <div class="d-flex justify-content-end mb-2">
            <button mat-stroked-button color="primary" class="me-2" matTooltip="Agregar nueva fila" (click)="addRow()">Agregar Fila <mat-icon>add</mat-icon></button>
            <button mat-stroked-button color="accent" class="me-2" matTooltip="Revertir cambios"  (click)="revertChanges()" [disabled]="!hasChanges">Revertir <mat-icon>edit</mat-icon></button>
            <button mat-stroked-button mat-dialog-close class="me-2">Cerrar <mat-icon>close</mat-icon></button>
            <button mat-raised-button color="primary" (click)="saveChanges()"  matTooltip="Guardar cambios"  [disabled]="!hasChanges">Guardar <mat-icon>save</mat-icon></button>
        </div>

        <div class="promo-container mat-elevation-z0 table-responsive text-nowrap"
            style="height: 70vh; overflow-y: auto; padding: 10px; border: 1px solid #ccc;">
            <mat-form-field appearance="standard" class="filter-field">
                <mat-label>Filtro</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ej. Mia" #input>
            </mat-form-field>

            <table mat-table [dataSource]="dspromotionFile" matSort class="mat-elevation-z8" style="width: 100%;">

                <!-- Dinamic Columns -->
                <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="do-jump-line-make-bonito"
                        style="min-width: 170px; margin-left: 14px;">
                        <span style="display: block; height: 33px;">{{column}} </span>
                    </th>
                    <td mat-cell *matCellDef="let promo; let i = index" 
                        (click)="editCell(i, column)" 
                        style="min-width: 170px; margin-left: 14px; cursor: pointer;">
                        <ng-container *ngIf="editing.rowIndex !== i || editing.column !== column">
                            {{promo[column]}}
                        </ng-container>
                        <ng-container *ngIf="editing.rowIndex === i && editing.column === column">
                            <input class="cell-input" 
                                   [type]="getCellType(promo[column])"
                                   [value]="promo[column] ?? ''" 
                                   (blur)="finishEditing($event, i, column)" autofocus>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef class="do-jump-line-make-bonito"
                    style="min-width: 70px; margin-left: 3px;"> </th>
                    <td mat-cell *matCellDef="let row; let i = index;">
                        <button mat-icon-button color="warn" (click)="deleteRow(i, row)" matTooltip="Eliminar fila">
                            <mat-icon>delete_outline</mat-icon>
                        </button>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: allColumns;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No hay datos que coincidan con el filtro "{{input.value}}"</td>
                </tr>
            </table>

            <div *ngIf="!isLoading"
                style="display: flex; justify-content: center; align-items: center; background: white;">
            </div>
            <mat-paginator [pageSizeOptions]="[10, 25, 100]" #paginator></mat-paginator>
        </div>
    </div>
</mat-dialog-content>
<!--<div class="modal-footer">
    <button mat-stroked-button mat-dialog-close>Cerrar</button>
    <button mat-raised-button color="primary" (click)="onSubmit()">Guardar</button>
</div>-->